module.exports = __webpack_public_path__ + "img/menu-contributors-icon.1d4ba3cb.svg";